// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900);"]);
// Module
exports.push([module.id, ".controls[data-v-e1820dc8]{position:absolute;top:0;left:0;display:flex;flex-direction:column;justify-content:center;text-align:center;align-items:center;cursor:pointer}.controls>i[data-v-e1820dc8]{margin-bottom:5px}.controls>p[data-v-e1820dc8]{font-weight:700;color:#fff;width:80%;margin:0}.controls .initials-container[data-v-e1820dc8]{display:flex;justify-content:center;align-items:center;font-size:1.5em;background-color:#3498db}", ""]);
// Exports
module.exports = exports;
